module.exports = __webpack_public_path__ + "static/media/32.36743ea7.png";